import { useQuery } from "react-query";
import { mapboxV6Api } from "../api/mapboxV6Api";

interface MapboxResponse {
  token: string;
}

export const useMapboxToken = () =>
  useQuery<MapboxResponse>({
    queryKey: ["mapbox-token"],
    queryFn: () => mapboxV6Api.token(),
    onError: err => console.error(err),
  });
